import { arrayOf, bool, shape, string } from 'prop-types'

export const ImageRowItem = shape({
  id: string,
  imageUrl: string,
  name: string,
})

export const ImageRowProps = {
  items: arrayOf(ImageRowItem).isRequired,
  keepImageSize: bool,
}
